import { useCallback, useState } from "react";
import { changePassword, getProfileErrorMessage, type ChangePasswordRequest } from "../api/profile.api";

interface UseChangePasswordReturn {
  changePassword: (request: ChangePasswordRequest) => Promise<void>;
  error: string | null;
  loading: boolean;
  reset: () => void;
}

export const useChangePassword = (): UseChangePasswordReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submitChange = useCallback(
    async (request: ChangePasswordRequest) => {
      if (loading) {
        return;
      }

      setLoading(true);
      setError(null);

      try {
        await changePassword(request);
      } catch (error: unknown) {
        setError(getProfileErrorMessage(error, "Failed to change password"));
        throw error;
      } finally {
        setLoading(false);
      }
    },
    [loading],
  );

  const reset = useCallback(() => setError(null), []);

  return { changePassword: submitChange, loading, error, reset };
};
